module.exports = __webpack_public_path__ + "img/img4.c97959b0.svg";